import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';

export default function PaginationBar({ resultsLength, pageCount, currentPage, pageResults, tempPage, onTempPageChange, onPageResultsChange, onPageChange }) {
    const { t } = useTranslation();

    return (
        <Row className="pagination-row mb-2">
            <Col sm={12}>
                <div>
                    <span className="bold">{resultsLength}</span> {t("pagination.results")} | {t("pagination.view")}
                    <div className="paginate-results">
                        <input name="tempPage" type="text" value={tempPage} onChange={onTempPageChange} className="form-control" />
                        <button className="btn btn-black btn-pagenav" onClick={onPageResultsChange}>{t("pagination.go")}</button>
                    </div>
                </div>

                <div className="paginate-selector">

                    <button onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 0}
                        type="button"
                        className="btn btn-black btn-pagenav"
                    >
                        {'<'}
                    </button>

                    <span>{t("pagination.page")}</span>

                    <select value={currentPage} onChange={(e) => onPageChange(Number(e.target.value))} title="Current Page" name="Current Page">
                        {Array.from({ length: pageCount }).map((_, i) => (
                            <option key={i} value={i}>
                                {i + 1}
                            </option>
                        ))}
                    </select>

                    <span>{t("pagination.of")} {pageCount}</span>

                    <button onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === pageCount - 1}
                        type="button"
                        className="btn btn-black btn-pagenav"
                    >
                        {'>'}
                    </button>

                    {/*Hidden ReactPaginate for logic only */}
                    {pageCount > 0 && (
                        <ReactPaginate pageCount={pageCount} forcePage={currentPage} onPageChange={(e) => onPageChange(e)}
                            containerClassName="hidden"
                        />
                    )}
                </div>
            </Col>
        </Row>
    )
}